import {GetterTree, Module, MutationTree} from "vuex";
import {SortOption} from "@/domain/sort/SortOption";

export class SortOptionState {
  constructor() {
    this.sortOptionList = [];
    this.selectedIndex = 0;
  }

  public sortOptionList: Array<SortOption>;
  public selectedIndex: number;
}

const getters: GetterTree<SortOptionState, any> = {
  getSortOptionName(state: SortOptionState): string {
    return state.sortOptionList[state.selectedIndex].name;
  },

  getSortOptionValue(state: SortOptionState): string {
    return state.sortOptionList[state.selectedIndex].value;
  },
};

const mutations: MutationTree<SortOptionState> = {
  initSortOption(state: SortOptionState, sortOptionList: Array<SortOption>) : void {
    state.sortOptionList = sortOptionList;
    state.selectedIndex = 0;
  },

  setSortOptionByString(state: SortOptionState, sortBy: string): void {
    state.sortOptionList[state.selectedIndex].isSelected = false;
    for (let index = 0; index < state.sortOptionList.length; index++) {
      const sortOption = state.sortOptionList[index];
      if (sortOption.name === sortBy) {
        sortOption.isSelected = true;
        state.selectedIndex = index;
        break;
      }
    }
  },

  setSortOption(state: SortOptionState, index: number): void {
    state.sortOptionList[state.selectedIndex].isSelected = false;
    state.sortOptionList[index].isSelected = true;
    state.selectedIndex = index;
  },
};

export const SortOptionStore: Module<SortOptionState, any> = {
  namespaced: true,
  state: new SortOptionState(),
  mutations,
  getters,
};